import { t } from '@lingui/macro'
import { useState } from 'react'
import styled, { useTheme } from 'styled-components'

import { FlexColumn, FlexRow, Padding } from '@/@bothrs-ui/web/components/layout'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { H4 } from '@/@bothrs-ui/web/components/typography/Heading'
import { useBadgeCount } from '@/modules/notifications/hooks/useBadgeCount'
import { BadgeService } from '../../services/badgeService'

export const BadgeTest = () => {
  const theme = useTheme()
  const { badgeCount, updateBadgeCount } = useBadgeCount()
  const [isSupported, setIsSupported] = useState<boolean | null>(null)

  const checkBadgeSupport = async () => {
    const supported = await BadgeService.isSupported()
    setIsSupported(supported)
  }

  const setBadge = async (count: number) => {
    await BadgeService.setBadgeCount(count)
  }

  const clearBadge = async () => {
    await BadgeService.clearBadge()
  }

  return (
    <StyledCard>
      <Padding p={theme.UI.Spacing.Space4}>
        <FlexColumn gap={theme.UI.Spacing.Space4}>
          <H4>{t`Beheer app-badge`}</H4>

          <FlexRow gap={theme.UI.Spacing.Space4}>
            <Button variant='Primary' onClick={checkBadgeSupport}>
              {t`Check of badges ondersteund worden`}
            </Button>
            {isSupported !== null && (
              <Span type='BodySmallRegular'>
                {isSupported
                  ? t`Badges worden ondersteund op dit apparaat`
                  : t`Badges worden niet ondersteund op dit apparaat`}
              </Span>
            )}
          </FlexRow>

          <FlexRow gap={theme.UI.Spacing.Space4}>
            <Button variant='Primary' onClick={() => setBadge(badgeCount ?? 0)}>
              {t`Zet badge op aantal taken (${badgeCount})`}
            </Button>
            <Button variant='Primary' onClick={() => setBadge(5)}>
              {t`Zet badge op 5`}
            </Button>
            <Button variant='Primary' onClick={clearBadge}>
              {t`Wis badge`}
            </Button>
          </FlexRow>

          <FlexRow gap={theme.UI.Spacing.Space4}>
            <Button variant='Primary' onClick={updateBadgeCount}>
              {t`Ververs taak telling`}
            </Button>
            <Span type='BodySmallRegular'>{t`Aantal openstaande taken: ${badgeCount}`}</Span>
          </FlexRow>
        </FlexColumn>
      </Padding>
    </StyledCard>
  )
}

const StyledCard = styled.div`
  background-color: ${({ theme }) => theme.Colors.Background.White};
  border-radius: ${({ theme }) => theme.UI.BorderRadius.Small}px;
  box-shadow: 0px 0px 20px rgba(23, 39, 57, 0.08);
`
